/* eslint-disable unused-imports/no-unused-vars */
import { Injectable } from '@angular/core';
import { GridItem } from 'components/queue-view/models/grid-item.interface';
import { chatClosedColumnsWithTimeCondition, emailClosedColumnsWithTimeCondition, messagingClosedColumnsWithTimeCondition } from 'components/queue-view/queue-view-tab/models/time-conditions/time-conditions';
import { cloneDeep } from 'lodash';
import { BackendFieldConverterService } from 'shared/services/backend-field-converter/backend-field-converter.service';
import Moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class WorkItemExportService {
  constructor(private _backendFieldConverter: BackendFieldConverterService) {
  }

  public exportWorkItems(originalFilteredGridItems: GridItem[], isClosedTabActive: boolean, gridName: string): void {
    if (!originalFilteredGridItems || !originalFilteredGridItems.length) {
      return;
    }

    const filteredItems: GridItem[] = cloneDeep(originalFilteredGridItems);

    if (isClosedTabActive) {
      const defaultPropertyNames = new Set(chatClosedColumnsWithTimeCondition.map(item => item.valueProperty));

      const timeConditionFields = [
        ...chatClosedColumnsWithTimeCondition,
        ...emailClosedColumnsWithTimeCondition.filter(item => !defaultPropertyNames.has(item.valueProperty)),
        ...messagingClosedColumnsWithTimeCondition.filter(item => !defaultPropertyNames.has(item.valueProperty))
      ].map(item => item.valueProperty);

      filteredItems.forEach(item => {
        Object.keys(item).forEach(key => {
          if (timeConditionFields.includes(key)) {
            item[key] = this._backendFieldConverter.isoDateFormatter(item[key]);
          }
        });
      });
    }

    const csvContent = this._convertFilteredItemsToCsvString(filteredItems);
    const data: Blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const fileName = `${gridName}-${Moment().format('L')}.csv`;

    let a = document.createElement('a');
    a.download = fileName;
    a.rel = 'noopener'; // tabnabbing
    a.href = URL.createObjectURL(data);

    setTimeout(() => {
      URL.revokeObjectURL(a.href);
    }, 4E4); // 40s
    setTimeout(() => {
      a.dispatchEvent(new MouseEvent('click'));
    }, 0);
  }

  private _convertFilteredItemsToCsvString(filteredItems: GridItem[]): string {
    if (!filteredItems || !filteredItems.length) {
      return '';
    }

    const separator = ',';

    const itemsToExport = filteredItems.map(
      ({
         keepAlive,
         type,
         isClosable,
         checked,
         columnsShouldBeWarned,
         Flagged,
         // @ts-ignore
         _avatarThemeId,
         // @ts-ignore
         _id,
         // @ts-ignore
         _isCollapsible,
         ...keepAttrs
       }) => keepAttrs
    );

    const keys = Object.keys(itemsToExport[0]);

    const csvContent =
      keys.join(separator) +
      '\n' +
      filteredItems.map(item => {
        return keys.map(key => {
          let cell = item[key] === null || item[key] === undefined ? '' : item[key];
          cell = cell.toString().includes('"') ? cell.replace('"', '""') : cell;
          return `"${cell}"`;
        }).join(separator);
      }).join('\n');

    return csvContent;
  }
}
